import { render, staticRenderFns } from "./ImportXLS.vue?vue&type=template&id=708aa416"
import script from "./ImportXLS.vue?vue&type=script&lang=js"
export * from "./ImportXLS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports